import { Platform } from 'react-native';

import AccountOrdersPage from '@fhs-legacy/frontend/src/pages/account/account-orders';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';

import { UnauthenticatedRecentOrders } from '../../../../components/unauthenticated-recent-orders';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RecentOrdersRoute() {
  const { isAuthenticated } = useAuthContext();

  // The unauthenticated recent orders screen is only shown on native bottom nav.
  if (Platform.OS !== 'web' && !isAuthenticated) {
    return <UnauthenticatedRecentOrders />;
  }

  return <AccountOrdersPage />;
}
